import { CaseCardMobile, CaseCardWeb } from '@components/cases';
import { CaseSliderCard } from '@components/casesSlider';
import { memo } from 'react';

export const CasesContent = memo(
  ({ isLoading, cases }: { isLoading: boolean; cases: CaseSliderCard[] }) => {
    if (isLoading) {
      return null;
    }

    return cases.length ? (
      cases?.map((card) => (
        <div key={card.id}>
          <div className="h-full max-sm:hidden">
            <CaseCardWeb card={{ ...card, imgHeight: 260 }} />
          </div>
          <div className="lg:hidden">
            <CaseCardMobile card={card} />
          </div>
        </div>
      ))
    ) : (
      <div className="text-text-base-tertiary absolute inset-0 m-auto h-fit text-center text-sm leading-6">
        Ничего не найдено
      </div>
    );
  },
);

CasesContent.displayName = 'CasesContent';
